import type { TextMatchTransformer } from "@lexical/markdown"

import { $createCitationNode, $isCitationNode, CitationNode, type Citation } from "../nodes/citation"

// Pattern: {{cite:base64-encoded-json}}
const CITATION_REGEX = /\{\{cite:([A-Za-z0-9+/=]+)\}\}/

export const CitationTransformer: TextMatchTransformer = {
  type: "text-match",
  dependencies: [CitationNode],
  regExp: CITATION_REGEX,
  importRegExp: CITATION_REGEX,
  replace: (textNode, match) => {
    try {
      const encoded = match[1]
      // Unicode-safe decode
      const jsonStr = decodeURIComponent(escape(atob(encoded)))
      const citations: Citation[] = JSON.parse(jsonStr)
      const citationNode = $createCitationNode(citations)
      textNode.replace(citationNode)
    } catch {
      // If decoding fails, leave text as-is
      return
    }
  },
  trigger: "}",
  export: (node) => {
    if (!$isCitationNode(node)) {
      return null
    }
    // Unicode-safe encode
    const jsonStr = JSON.stringify(node.__citations)
    const encoded = btoa(unescape(encodeURIComponent(jsonStr)))
    return `{{cite:${encoded}}}`
  },
}
